<template src="./MerchantDetails/MerchantReturn.html"></template>
<script>
import ImageGallery from '@/widgets/ImageGallery'
import estateTypeLabels from '@/utils/estate-type-labels'

export default {
    name: 'MerchantReturn',
    components: {
        ImageGallery,
    },
    props: {
        consignment: Object,
        returnPallets: Array,
    },
    data: () => ({
        openImageGallery: false,
        imageGalleryTitle: '',
        imageGalleryImages: [],
    }),
    computed: {
        estateType() {
            return estateTypeLabels[this.$props.consignment.address.settings.estateType]
        },
    },
    methods: {
        onGalleryClose() {
            this.openImageGallery = false
        },
        onPhotosOpen() {
            this.openImageGallery = true
            this.imageGalleryTitle = 'Photos'
            this.imageGalleryImages = this.consignment.signatures.map((image) => image.url)
        },
    },
}
</script>
<style lang="scss" scoped>
.card {
    margin-bottom: 10px;
}

.task-dashboard {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-left: solid 0px slategrey;
}

.dashboard-row {
    display: flex;
    width: 100%;
}

.dashboard-row-single {
    margin-right: 10px;
}

.dashboard-row-child {
    flex: 1;
    margin-right: 10px;
}

.something {
    table-layout: fixed;
}
</style>
